import './invoice.css';
import React, { useContext, useEffect, useState } from 'react';
import { Cookies, useCookies } from 'react-cookie';
import { Table, InputGroup, Button, Form, Dropdown, Pagination, Badge } from 'react-bootstrap';
import { fetchInvoice, fetchInvoicePDF, fetchPODPDF } from '../API/apiservice';
import { KSGPagination } from '../Utility/pagination';
import { toCurrency, formatDate, formatLastUpdateDate, getDate } from '../Utility/utility';
import { LoadingSign } from "../Utility/loading-sign";
import { ApiErrorMessage } from '../Utility/errorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import ConvergePayButton from "./ConvergePayButton";


export const Invoice = (props) => {
    // const [cookies, setCookie] = useCookies(['user']);
    const cookies = new Cookies();
    const [lastUpdate, setLastUpdate] = useState("");
    const [invoiceData, setInvoiceData] = useState([]);
    const [creditMemoData, setCreditMemoData] = useState([]);
    const [agingData, setAgingData] = useState({});
    const [currentData, setCurrentData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [activePage, setActivePage] = useState(1);
    //const [displayFilter, setDisplayFilter] = useState(cookies.get('customers').toString());
    const [displayFilter, setDisplayFilter] = useState(JSON.parse(localStorage.getItem('customers')));
    const [storeNames, setStoreNames] = useState(JSON.parse(localStorage.getItem('storeList')));
    const [statusFilter, setStatusFilter] = useState("Open");
    const [searchText, setSearchText] = useState('');
    const [searchClicked, setSearchClicked] = useState(false);
    const [sortField, setSortField] = useState('DueDate');
    const [sortOrder, setSortOrder] = useState('asc');
    const [isApiError, setIsApiError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isCorporate, setIsCorporate] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [creditAging, setCreditAging] = useState({current: 0, days30: 0, days60: 0, days90: 0, days120: 0});

    useEffect(() => {
        if(props.validateCookies())
        {
            setIsLoading(true);
            let isCorporateAccount = cookies.get('isCorporate');
            //let customersList = cookies.get('customers');
            let customersList = JSON.parse(localStorage.getItem('customers'));

            setIsCorporate(isCorporateAccount);
            setCustomers(customersList);
            const getData = async () => {
                const params = {
                    page: activePage, size: 100, 
                    //customerNumber: isCorporateAccount ||  customersList.length > 0 ? ","+displayFilter+"," : ","+cookies.get('customers').toString()+",", 
                    customerNumber: isCorporateAccount ||  customersList.length > 0 ? ","+displayFilter+"," : ","+JSON.parse(localStorage.getItem('customers'))+",", 
                    custNum: displayFilter,
                    sort: sortField, 
                    direction: sortOrder, 
                    status:  statusFilter, 
                    search: searchText,
                    userName: cookies.get('email'),
                    warehouse: cookies.get('warehouse')
                };
                const data = await fetchInvoice(params);
                Array.isArray(data) && data[0] == 'error' && setIsApiError(true);
                setLastUpdate(data.lastUpdate);
                setInvoiceData(data.invoiceData);
                setCreditMemoData(data.creditMemoData);
                let current = 0;
                let days30 = 0;
                let days60 = 0;
                let days90 = 0;
                let days120 = 0;
                const currentDate = new Date(getDate());
                data.creditMemoData.map((credit) => {
                    const dueDate = new Date(formatDate(credit.dueDate));
                    let diff = currentDate.getTime() - dueDate.getTime();
                    let diffDays = Math.round(diff / (1000 * 3600 * 24));
                    if(diffDays <= 30 ) 
                    {
                        current += Number(credit.invoiceAmount); 
                    }
                    if(diffDays > 30 && diffDays <= 60) 
                    {
                        days30 += Number(credit.invoiceAmount); 
                    }
                    if(diffDays > 60 && diffDays <= 90) 
                    {
                        days60 += Number(credit.invoiceAmount); 
                    }
                    if(diffDays > 90 && diffDays <= 120) 
                    {
                        days90 += Number(credit.invoiceAmount);  
                    }
                    if(diffDays > 120) 
                    {
                        days120 += Number(credit.invoiceAmount); 
                    }
                });
                setCreditAging({current: current, days30: days30, days60: days60, days90: days90, days120: days120});
                setAgingData(data.agingData);
                setTotalItems(data.total);
                setTotalInvoiceAmount(data.totalInvoiceAmount);
                setTotalPaidAmount(data.totalPaidAmount);
                setIsLoading(false);
                // console.log("invoice page: ", storeNames);
                // console.log("invoice page: ", customersList);
            };
            let timer;
            const debounceGetData = () => {
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(getData, 500);
            };
    
            debounceGetData();
    
            return () => {
                clearTimeout(timer);
            };
        }
    
    }, [activePage, statusFilter, sortField, sortOrder, displayFilter, searchClicked]
    )

    const obtainCurrentData = (newData) => {
        setCurrentData(newData);
    };

    const handleSortClick = (field) => {
        // setIsLoading(true);
        if (sortField === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('asc');
        }
    };

    const changeDisplayFilter = (event) => {
        setDisplayFilter(event.target.value);
    };

    const changeStatus = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleInputChange = (event) => {
        setSearchText(event.target.value);
    }

    const handleSearchClick = () => {
        setSearchClicked(!searchClicked);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearchClick();
        }
    }

    const printInvoice = (guid) => {
        // setIsGenerateError(false);
        // setShowConfirmation(false);
        const printInvoicePDF = async () => {
            setIsLoading(true);
            let params = { guid: guid}
            const response = await fetchInvoicePDF(params);
            if(Array.isArray(response) && response[0] == 'error') {
                setIsApiError(true);
            }
            setIsLoading(false);
            // else {

            // }
            // props.changeIsModalLoading(false);
        };

        props.validateCookies() && printInvoicePDF();   
    };

    const printPOD = (shipmentId) => {
        // setIsGenerateError(false);
        // setShowConfirmation(false);
        const printPODPDF = async () => {
            setIsLoading(true);
            let params = { shipmentId: shipmentId}
            const response = await fetchPODPDF(params);
            if(Array.isArray(response) && response[0] == 'error') {
                setIsApiError(true);
            };
            setIsLoading(false);
            // else {

            // }
            // props.changeIsModalLoading(false);
        };

        props.validateCookies() && printPODPDF();   
    };

    const renderTableRows = () => {
        return currentData.map((row, index) => (
            <tr key={index}>
                { (isCorporate || customers.length) > 0 &&
                <td className="gridlongrowcontent">{row.customerName} - {row.storeName}</td>
                }
                <td>{row.orderNum}</td>
                <td>{row.invoiceNum}</td>
                {/* <td>{formatDate(row.shipDate)}</td> */}
                <td>{formatDate(row.invoiceDate)}</td>
                <td>{formatDate(row.dueDate)}</td>
                {/* <td>{row.shipTo}</td> */}
                {/* <td>{toCurrency(row.invoiceAmount)}</td> */}
                {
                    Number(row.debitAmount) > 0 ?
                    <td title={`Invoice Amt:  ${toCurrency(row.invoiceAmount)}, Debit Amt: ${toCurrency(row.debitAmount)}`}>{toCurrency(Number(row.invoiceAmount) + Number(row.debitAmount))}</td>
                    :
                    <td>{toCurrency(Number(row.invoiceAmount) + Number(row.debitAmount))}</td>
                }
                <td>{toCurrency(Math.abs(row.paymentAmount))}</td>
                <td>{toCurrency(row.invoiceAmount - Math.abs(row.paymentAmount) + Number(row.debitAmount))}</td>
                <td>{row.status}</td>
                <td><i className="bi bi-download downloadIcon" onClick={() => printInvoice(row.guid)}></i></td>
                {row.pod ? <td><i className="bi bi-download downloadIcon" onClick={() => printPOD(row.shipmentId)}></i></td> : <td></td>}
            </tr>
        ));
    };

    const renderCreditMemoTableRows = () => {
        return creditMemoData.map((row, index) => (
            <tr key={index}>
                <td className="gridlongrowcontent">{row.customerName} - {row.storeName}</td>
                <td>{row.orderNum}</td>
                <td>{row.invoiceNum}</td>
                <td>{formatDate(row.invoiceDate)}</td>
                <td>{formatDate(row.dueDate)}</td>
                <td>{toCurrency(Math.abs(row.invoiceAmount))}</td>
                <td>{row.type}</td>
            </tr>
        ));
    };

    return (
        <>
        <ApiErrorMessage isApiError={isApiError}/>
        {
            !isApiError &&
            <div className="container row">
            <LoadingSign isLoading={isLoading} />
            <p className="updateMsg">Last updated on {formatLastUpdateDate(lastUpdate)}</p>
            <ConvergePayButton />
            <div className="row gridactionitemrow">
                <div className={`${(isCorporate || customers.length > 0) ? "col-sm-3" : "col-sm-9"} titleContainer noShrink`}><h4 className="componenttitle">Aging</h4></div>
                {
                    (isCorporate || customers.length > 0) &&
                    <div className="col-sm-6 statusFilter noShrink">
                    <Form.Select aria-label="Default select example" value={displayFilter} onChange={changeDisplayFilter}>
                    <option value={customers.toString()}>Display All</option>
                    {
                            customers.map((customer, key) => (
                                <option value={customer} key={key}>{storeNames ? customer + " - " + storeNames[key] : ""}</option>
                            ))                    
                            }
                    </Form.Select>
                    </div>
                }

                <div className="col-sm-2 statusFilter noShrink">
                <Form.Select aria-label="Default select example" value={statusFilter} onChange={changeStatus}>
                <option value="All">All</option>
                <option value="Paid">Paid</option>
                <option value="Open">Open</option>
                {/* <option value="Partial">Partial</option> */}
                </Form.Select>
                </div>

                <div className="col-sm-3 searchContainer">
                <InputGroup>
                    <Form.Control
                        className="searchbar"
                        placeholder="Search..."
                        aria-describedby="searchbtn"
                        onChange={handleInputChange}
                        value={searchText}
                        onKeyDown={handleKeyDown} />
                    <InputGroup.Text id="searchbtn" onClick={handleSearchClick}>
                        <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                </InputGroup>
                </div>
            </div>
            <Table bordered className="agingTable">
                <thead>
                    <tr>
                        <th style={{ width: "16%" }}>Current</th>
                        <th style={{ width: "16%" }}>Over 30 Days</th>
                        <th style={{ width: "16%" }}>Over 60 Days</th>
                        <th style={{ width: "16%" }}>Over 90 Days</th>
                        <th style={{ width: "16%" }}>Over 120 Days</th>
                        <th style={{ width: "20%" }}>Total Open Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{toCurrency(Number(agingData.current) + creditAging.current)}</td>
                        <td>{toCurrency(Number(agingData.days30) + creditAging.days30)}</td>
                        <td>{toCurrency(Number(agingData.days60) + creditAging.days60)}</td>
                        <td>{toCurrency(Number(agingData.days90) + creditAging.days90)}</td>
                        <td>{toCurrency(Number(agingData.days120) + creditAging.days120)}</td>
                        {/* <td>{toCurrency(totalInvoiceAmount + totalPaidAmount)}</td> */}
                        <td>{toCurrency(Number(agingData.current) + creditAging.current + Number(agingData.days30) + creditAging.days30 + 
                        Number(agingData.days60) + creditAging.days60 + Number(agingData.days90) + creditAging.days90 + Number(agingData.days120) + creditAging.days120)}</td>

                    </tr>
                </tbody>
            </Table>

            {   
                creditMemoData.length > 0 &&
                <>
                <div className="col-sm-7 titleContainer"><h4 className="componenttitle creditMemoTitle">Open Credit Memo/Payment</h4></div>
                <Table striped bordered hover>
                    <thead className="darktableheader">
                        <tr>
                            <th style={{ width: "40%" }}>Customer Name</th>
                            <th>Order #</th>
                            <th>Invoice #</th>
                            <th>Invoice Date</th>
                            <th>Due date</th>
                            <th>Invoice Amt</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderCreditMemoTableRows()}
                    </tbody>
                </Table>
                </>
            }

            <div className="col-sm-7 titleContainer"><h4 className="componenttitle invoiceTitle">Invoice</h4></div>
            <Table striped bordered hover>
                <thead className="darktableheader">
                    <tr>
                        { (isCorporate || customers.length > 0) &&
                        <th style={{ width: "26%" }} className="sortablecolumn" onClick={() => handleSortClick('StoreName')}>Customer Name {sortField === 'StoreName' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        }
                        <th className="sortablecolumn" onClick={() => handleSortClick('OrderNum')}>Order # {sortField === 'OrderNum' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        <th className="sortablecolumn" onClick={() => handleSortClick('InvoiceNum')}>Invoice # {sortField === 'InvoiceNum' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        {/* <th className="sortablecolumn" onClick={() => handleSortClick('ShipDate')}>Ship Date {sortField === 'ShipDate' && (sortOrder === 'asc' ? '▲' : '▼')}</th> */}
                        <th className="sortablecolumn" onClick={() => handleSortClick('InvoiceDate')}>Invoice Date {sortField === 'InvoiceDate' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        <th style={{ width: "8%" }} className="sortablecolumn" onClick={() => handleSortClick('DueDate')}>Due date {sortField === 'DueDate' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        {/* <th className="sortablecolumn" onClick={() => handleSortClick('ShipTo')}>ShipTo {sortField === 'ShipTo' && (sortOrder === 'asc' ? '▲' : '▼')}</th> */}
                        <th style={{ width: "9%" }} className="sortablecolumn" onClick={() => handleSortClick('InvoiceAmount')}>Invoice Amt {sortField === 'InvoiceAmount' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        <th style={{ width: "10%" }} className="sortablecolumn" onClick={() => handleSortClick('PaymentAmount')}>Pay/Credit Amt {sortField === 'PaymentAmount' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        <th style={{ width: "7%" }}>Balance</th>
                        <th style={{ width: "6%" }} className="sortablecolumn" onClick={() => handleSortClick('Status')}>Status {sortField === 'Status' && (sortOrder === 'asc' ? '▲' : '▼')}</th>
                        <th style={{ width: "4%" }}>Invoice</th>
                        <th style={{ width: "4%" }}>POD</th>
                    </tr>
                </thead>
                <tbody>
                    {invoiceData ? renderTableRows() : null}
                </tbody>
            </Table>
            <KSGPagination  data={invoiceData} totalItems={totalItems} onData={obtainCurrentData} setActivePage={setActivePage}/>
            </div>
        }
        </>
    );
};